import {
  ERROR_LOADING_PORTALS,
  GET_ALL_PORTALS,
  RESET_DATA,
  START_LOADING_PORTALS,
  STOP_LOADING_PORTALS,
} from "./action-types";
import initialState from "./initialState";

export const dataPortalReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case START_LOADING_PORTALS:
      return {
        ...state,
        stateIs: "Pending",
      };

    case ERROR_LOADING_PORTALS:
      return {
        ...state,
        stateIs: "Error",
      };

    case STOP_LOADING_PORTALS:
      return {
        ...state,
        stateIs: "Idle",
      };
    case GET_ALL_PORTALS:
      const dataPortals = action.payload.portals.map((item: any) => {
        const {
          id,
          size,
          status,
          file,
          description,
          extension,
          author,
          publisher,
          creationDate,
          fileType,
          uploadStatus
        } = item;

        return {
          id,
          size,
          status,
          file,
          description,
          fileExtension: extension,
          author,
          publisher,
          creationDate,
          fileType,
          uploadStatus
        };
      });
      return {
        ...state,
        data: {
          portals: dataPortals,
          totalItems: action.payload.totalItems,
          totalPages: action.payload.totalPages,
          currentPage: action.payload.currentPage,
        },
        message: "",
        stateIs: "Idle",
      };

    case RESET_DATA: {
      return initialState;
    }
    default:
      return state;
  }
};
